/**
 * DealbreakersEditor.jsx — Employer v1.1 Phase 0.6 Slice B.
 *
 * Structured editor for the four locked dealbreaker keys.
 * Unknown keys are not selectable (mirrors backend Pydantic).
 */
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const ALLOWED_DEALBREAKER_KEYS = [
  'timezone',
  'clearance',
  'work_authorization',
  'language',
];

const PLACEHOLDER = {
  timezone:           'e.g. UTC±2',
  clearance:          'e.g. SC required',
  work_authorization: 'e.g. UK right-to-work',
  language:           'e.g. English C1',
};

export default function DealbreakersEditor({ value, onChange }) {
  const dealbreakers = (value && typeof value === 'object') ? value : {};

  function setKey(k, v) {
    if (v === undefined || v === null || v === '') {
      const next = { ...dealbreakers };
      delete next[k];
      onChange(next);
    } else {
      onChange({ ...dealbreakers, [k]: v });
    }
  }

  return (
    <div className="space-y-3" data-testid="dealbreakers-editor">
      {ALLOWED_DEALBREAKER_KEYS.map((k) => {
        const v = dealbreakers[k] || '';
        return (
          <div
            key={k}
            className="grid grid-cols-3 items-center gap-3"
            data-testid={`dealbreaker-row-${k}`}
          >
            <Label className="text-sm capitalize text-slate-200">
              {k.replace(/_/g, ' ')}
            </Label>
            <Input
              type="text"
              value={v}
              maxLength={200}
              placeholder={PLACEHOLDER[k]}
              onChange={(e) => setKey(k, e.target.value)}
              className="col-span-2"
              data-testid={`dealbreaker-input-${k}`}
            />
            {v ? (
              <Button
                type="button"
                size="sm"
                variant="ghost"
                onClick={() => setKey(k, '')}
                className="col-start-3 justify-self-end -mt-3"
                data-testid={`dealbreaker-clear-${k}`}
              >
                <Trash2 className="mr-1 h-3 w-3" />
                Clear
              </Button>
            ) : null}
          </div>
        );
      })}
      <p className="text-xs text-slate-300">
        Dealbreakers are evaluated in Phase 2.E. Unknown keys are not
        accepted by the backend.
      </p>
    </div>
  );
}
